import React from 'react';
import { useState } from 'react';
import { Button, Input, Modal, ModalHeader } from 'reactstrap';

export const ModalReasonCancel = (props) => {
  const [cancelationReason, setCancelatinReason] = useState('');

  const handleCancelationForm = () => {
    props.handleSubmit(cancelationReason);
    handleCleanupState();
  };

  const handleCleanupState = () => {
    setCancelatinReason('');
  };

  return (
    <Modal
      id="fadeInleftModal"
      isOpen={props.isOpen}
      toggle={() => {
        props.toogle();
      }}
      modalClassName="fadeInLeft"
      centered
      autoFocus={false}
    >
      <ModalHeader>{props.title}</ModalHeader>
      <div className="modal-body">
        <form
          autoComplete="off"
          onSubmit={(e) => {
            handleCancelationForm(e);
          }}
        >
          <div className="mb-3">
            <label htmlFor="type-name" className="col-form-label">
              {props.label}
            </label>
            <Input
              autoFocus={true}
              type="textarea"
              className="form-control"
              id="typeName"
              onChange={(e) => setCancelatinReason(e.target.value)}
              value={cancelationReason}
              placeholder={props.placeholder}
              // defaultValue={props.value}
            />
          </div>
          <div className="text-end">
            <button
              type="button"
              className="btn btn-link"
              onClick={() => {
                props.toogle();
                handleCleanupState();
              }}
            >
              {' '}
              Voltar{' '}
            </button>
            <Button
              type="button"
              color="danger"
              onClick={handleCancelationForm}
            >
              {' '}
              Cancelar{' '}
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  );
};
